import { Dispatch, SetStateAction, useState } from 'react';

export interface UseResourcePanelValue<T extends Record<string, any>> {
  selectedResource: T | undefined;
  setSelectedResource: Dispatch<SetStateAction<T | undefined>>;
  panelVisible: boolean;
  closePanel: () => void;
  isEditing: boolean;
  setIsEditing: Dispatch<SetStateAction<boolean>>;
  openPanel: (isEditing: boolean, resourceOrId?: T | string) => void;
  isDeleting: boolean;
  setIsDeleting: Dispatch<SetStateAction<boolean>>;
  setSelectedResourceById: (id: string) => void;
  getResourceById: (id: string) => T | undefined;
}

export const useResourcePanel = <T extends Record<string, any>>(data?: T[]): UseResourcePanelValue<T> => {
  // TODO unify into one single state but maintain the same api for consumers
  const [selectedResource, setSelectedResource] = useState<T>();
  const [panelVisible, setPanelVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const getResourceById = (id: string) => {
    return data?.find((user) => user.id === id);
  };

  const setSelectedResourceById = (id: string) => {
    setSelectedResource(getResourceById(id));
  };

  const openPanel = (isEditing: boolean, resourceOrId?: T | string) => {
    setPanelVisible(true);
    setIsEditing(isEditing);
    if (typeof resourceOrId === 'string') {
      setSelectedResourceById(resourceOrId);
    } else {
      setSelectedResource(resourceOrId);
    }
  };

  const closePanel = () => {
    setPanelVisible(false);
  };

  return {
    selectedResource,
    setSelectedResource,
    panelVisible,
    closePanel,
    isEditing,
    setIsEditing,
    openPanel,
    isDeleting,
    setIsDeleting,
    setSelectedResourceById,
    getResourceById,
  };
};
